import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { Forgotpassword } from './pages/forgotpassword/forgotpassword';
import { Layout } from './layout/layout';
import { ComingSoon } from './shared/components/coming-soon/coming-soon';
import { Guard, LoginGuard } from './core/guards/guard';
import { PeopleListing } from './pages/people/people-listing/people-listing';

// export const routes: Routes = [
//   { path: '', redirectTo: 'login', pathMatch: 'full' },
//   { path: 'login', component: Login },
//   { path: 'forgotpassword', component: Forgotpassword },
//   { path: 'coming-soon', component: ComingSoon },
//   {
//     path: '',
//     component: Layout,
//     // Temporarily commenting out auth guard until login APIs are ready
//     canActivate: [Guard],
//     children: [
//       { path: 'dashboard',
//         loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon)
//        },
//       {
//         path: 'projects',
//         children: [
//           { path: '', redirectTo: 'projects-all', pathMatch: 'full' },
//           {
//             path: 'projects-all',
//             loadComponent: () => import('./pages/projects/projects-all/projects-all').then(m => m.ProjectsAll)
//           },
//           {
//             path: 'projects-i-own',
//             loadComponent: () => import('./pages/projects/projects-i-own/projects-i-own').then(m => m.ProjectsIOwn)
//           },
//           {
//             path: 'project-details/:id',
//              loadComponent: () => import('./pages/projects/project-details/project-details').then(m => m.ProjectDetails),
//             children: [
//               { path: '', redirectTo: 'detail', pathMatch: 'full' },
//               // { path: 'tasks', loadComponent: () => import('./pages/projects/project-tasks/project-tasks').then(m => m.ProjectTasks) },
//               { path: 'update',
//                 loadComponent: () => import('./pages/updates/updates').then(m => m.UpdatesComponent),
//                 data: { objCode: 'PROJECT', objName: 'Project' }
//               },
//               {
//                 path: 'tasks',
//                 loadComponent: () => import('./pages/projects/tasks/task-list/task-list').then(m => m.TaskList)
//               },
//             ]
//           },
//         ]
//       },
//       {
//         path: 'task-listing',
//         loadComponent: () => import('./pages/projects/tasks/task-list/task-list').then(m => m.TaskList)
//       },
//       {
//         path: 'clients-list',
//         // loadComponent: () => import('./pages/clients/clients').then(m => m.Clients)
//         loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon)
//       },
//       {
//         path: 'reporting',
//         loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon)
//       },
//       {
//         path: 'wysiwyg-test',
//         loadComponent: () => import('./pages/wysiwyg-editor-test/wysiwyg-editor-test').then(m => m.WysiwygEditorTest)
//       },
//       {
//         path: 'wysiwyg-editor-audio',
//         loadComponent: () => import('./pages/wysiwyg-editor-audio/wysiwyg-editor-audio').then(m => m.WysiwygEditorAudioComponent)
//       },
//       {
//         path: 'updates',
//         loadComponent: () => import('./pages/updates/updates').then(m => m.UpdatesComponent)
//       },
//       {
//         path: 'custom-filter',
//         loadComponent: () => import('./shared/components/custom-filter/custom-filter').then(m => m.CustomFilter)
//       }
//     ]
//   },
//   { path: 'error-screen', pathMatch: 'full',
//     loadComponent: () => import('./shared/components/error-screen/error-screen').then(m => m.ErrorScreen)
//   },
//   { path: '**', redirectTo: '/login' } // Catch all route should be last
// ];


//testt

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    component: Login,
    canActivate: [LoginGuard],
    data: {
      title: 'Login | WorkLuge',
      description: 'WorkLuge Login'
    },
  },
  {
    path: 'forgotpassword',
    component: Forgotpassword
  },
  { path: 'coming-soon', component: ComingSoon },
  {
    path: '',
    component: Layout,
    canActivate: [Guard], // Enable auth guard for protected routes
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/single-dashboard/single-dashboard').then(m => m.SingleDashboard),
        data: {
          title: 'Dashboard | WorkLuge',
          description: 'WorkLuge Dashboard - Manage your projects, track time, and collaborate with your team. View project status, team performance, and get insights into your work progress.'
        }
      },
      {
        path: 'dashboard-old',
        loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.Dashboard),
        data: {
          title: 'Dashboard (Legacy) | WorkLuge',
          description: 'WorkLuge Dashboard - Legacy role-based dashboard view.'
        }
      },
      {
        path: 'timesheets',
        loadComponent: () => import('./pages/timesheet/timesheet-listing/timesheet').then(m => m.Timesheet),
        data: {
          title: 'Timesheet | WorkLuge',
          description: 'WorkLuge Timesheet - Track and manage your work hours, log time entries, and monitor productivity. Submit timesheets, view time reports, and manage billable hours efficiently.'
        }
      },
      {
        path: 'reports',
        loadComponent: () => import('./pages/reports/reports-layout/reports-layout').then(m => m.ReportsLayout),
        data: {
          title: 'Reports | WorkLuge',
          description: 'WorkLuge Reports - View and analyze various reports including project reports, milestone reports, timesheet reports, and more.'
        },
        children: [
          { path: '', redirectTo: 'pm-project', pathMatch: 'full' },
          {
            path: 'pm-project',
            loadComponent: () => import('./pages/reports/pm-project-report/pm-project-report').then(m => m.PmProjectReport),
            data: {
              title: 'PM Project Report | WorkLuge',
              description: 'PM Project Report - View and analyze project management reports'
            }
          },
          {
            path: 'milestone',
            loadComponent: () => import('./pages/reports/milestone-report/milestone-report').then(m => m.MilestoneReport),
            data: {
              title: 'Milestone Report | WorkLuge',
              description: 'Milestone Report - Track and analyze project milestones'
            }
          },
          {
            path: 'daily-beacon',
            loadComponent: () => import('./pages/reports/daily-beacon-report/daily-beacon-report').then(m => m.DailyBeaconReport),
            data: {
              title: 'Daily Beacon Report | WorkLuge',
              description: 'Daily Beacon Report - View daily beacon activity and updates'
            }
          },
          {
            path: 'maintenance',
            loadComponent: () => import('./pages/reports/maintenance-report/maintenance-report').then(m => m.MaintenanceReport),
            data: {
              title: 'Maintenance Report | WorkLuge',
              description: 'Maintenance Report - View maintenance activities and schedules'
            }
          },
          {
            path: 'intl-hour',
            loadComponent: () => import('./pages/reports/intl-hour-report/intl-hour-report').then(m => m.IntlHourReport),
            data: {
              title: 'INTL Hour Report | WorkLuge',
              description: 'INTL Hour Report - Analyze international hours and utilization'
            }
          },
          {
            path: 'ai-saved-hour',
            loadComponent: () => import('./pages/reports/ai-saved-hour-report/ai-saved-hour-report').then(m => m.AiSavedHourReport),
            data: {
              title: 'AI Saved Hour Report | WorkLuge',
              description: 'AI Saved Hour Report - Track hours saved through AI automation'
            }
          },
          {
            path: 'timesheet',
            loadComponent: () => import('./pages/reports/timesheet-report/timesheet-report').then(m => m.TimesheetReport),
            data: {
              title: 'Timesheet Report | WorkLuge',
              description: 'Timesheet Report - View and analyze timesheet data'
            }
          }
        ]
      },
      {
        path: 'requests',
        loadComponent: () => import('./pages/projects/requests/requests').then(m => m.Requests),
         data: {
          title: 'Requests | WorkLuge',
          description: 'WorkLuge Requests - Submit, manage, and track work requests. Create new requests, assign them to team members, and monitor request status and approvals.'
        }
      },
      {
        path: 'request',
        children: [
          {
            path: 'request-details/:requestId',
            loadComponent: () => import('./pages/projects/requests/request-details/request-details').then(m => m.RequestDetails),
            data: {
              title: 'Request Details | WorkLuge',
              description: 'WorkLuge Request Details'
            },
            children: [
              { path: '', redirectTo: 'updates', pathMatch: 'full' },
              {
                path: 'updates',
                loadComponent: () => import('./pages/projects/updates/updates').then(m => m.UpdatesComponent),
                data: {
                  objCode: 'REQUEST',
                  objName: 'Request',
                  title: 'Request Updates | WorkLuge',
                  description: 'WorkLuge Request Updates'
                }
              },
              {
                path: 'approvals',
                loadComponent: () => import('./pages/projects/approvals/approvals').then(m => m.Approvals),
                data: {
                  objCode: 'REQUEST',
                  objName: 'Request',
                  title: 'Request Approvals | WorkLuge',
                  description: 'WorkLuge Request Approvals'
                },
              },
               {
                path: 'hours',
                loadComponent: () => import('./pages/projects/hours/hours-listing/hours-listing').then(m => m.HoursListing),
                data: {
                  objCode: 'REQUEST',
                  objName: 'Request',
                  title: 'Request Hours | WorkLuge',
                  description: 'WorkLuge Request Hours'
                },
              },
              {
                path: 'documents',
                loadComponent: () => import('./pages/projects/project-details/documents/documents').then(m => m.DocumentsComponent),
                data: {
                  objCode: 'REQUEST',
                  objName: 'Request',
                  title: 'Request Documents | WorkLuge',
                  description: 'WorkLuge Request Documents'
                },
              }
            ]
          }
        ]
      },
      {
        path: 'projects',
        children: [
          { path: '', redirectTo: 'projects-all', pathMatch: 'full' },
          {
            path: 'projects-all',
            loadComponent: () => import('./pages/projects/projects-all/projects-all').then(m => m.ProjectsAll),
            data: {
              title: 'Projects | WorkLuge',
              description: 'WorkLuge Projects - View and manage all your projects. Track project progress, assign tasks, monitor deadlines, and collaborate with your team on project deliverables.'
            }
          },
          {
            path: 'projects-i-own',
            loadComponent: () => import('./pages/projects/projects-i-own/projects-i-own').then(m => m.ProjectsIOwn),
            data: {
              title: 'Projects I Own | WorkLuge',
              description: 'WorkLuge Projects I Own - Manage projects where you are the owner. Create new projects, set project parameters, assign team members, and oversee project execution.'
            }
          },
          {
            path:'templates',
            loadComponent: () => import('./pages/projects/templates/templates-listing/templates-listing').then(m => m.TemplatesListing),
            data: {
              title: 'Templates | WorkLuge',
              description: 'WorkLuge Templates - Create and manage project templates. Use pre-built templates to quickly start new projects with standardized tasks, workflows, and project structures.'
            },
          },
          {
            path: 'project-details/:id',
            loadComponent: () => import('./pages/projects/project-details/project-details').then(m => m.ProjectDetails),
            data: {
              title: 'Project Details | WorkLuge',
              description: 'WorkLuge Project Details - View comprehensive project information, manage tasks, track progress, assign team members, and monitor project milestones and deliverables.'
            },
            children: [
              { path: '', redirectTo: 'tasks', pathMatch: 'full' },
              // { path: 'tasks', loadComponent: () => import('./pages/projects/project-tasks/project-tasks').then(m => m.ProjectTasks) },
              {
                path: 'updates',
                loadComponent: () => import('./pages/projects/updates/updates').then(m => m.UpdatesComponent),
                data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Update | WorkLuge',
                  description: 'WorkLuge Update'
                }
              },
              {
                path: 'tasks',
                loadComponent: () => import('./pages/projects/tasks/task-list/task-list').then(m => m.TaskList),
                 data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Projects Details | WorkLuge',
                  description: 'WorkLuge Projects Details'
                },
              },
              {
                path: 'issues',
                loadComponent: () => import('./pages/projects/issues/issue-listing/issue-listing').then(m => m.IssueListing),
                data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Project Details | WorkLuge',
                  description: 'WorkLuge Project Details'
                },
              },
              {
                path: 'revisions',
                loadComponent: () => import('./pages/projects/revisions/revision-listing/revision-listing').then(m => m.RevisionListing),
                data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Project Details | WorkLuge',
                  description: 'WorkLuge Project Details'
                },
              },
              {
                path: 'requests',
                loadComponent: () => import('./pages/projects/requests/request-listing/request-listing').then(m => m.RequestListing),
                data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Project Requests | WorkLuge',
                  description: 'WorkLuge Project Requests'
                },
              },
              {
                path: 'hours',
                loadComponent: () => import('./pages/projects/hours/hours-listing/hours-listing').then(m => m.HoursListing),
                data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Project Hours | WorkLuge',
                  description: 'WorkLuge Project Hours'
                },
              },
              {
                path: 'documents',
                loadComponent: () => import('./pages/projects/project-details/documents/documents').then(m => m.DocumentsComponent),
                data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Project Documents | WorkLuge',
                  description: 'WorkLuge Project Documents'
                },
              },
              {
                path: 'staffing',
                loadComponent: () => import('./pages/projects/project-details/project-staffing/project-staffing').then(m => m.ProjectStaffing),
                data: {
                  objCode: 'PROJECT',
                  objName: 'Project',
                  title: 'Project Staffing | WorkLuge',
                  description: 'WorkLuge Project Staffing - assign roles and team members to the project.'
                },
              },
              // {
              //   path: 'approvals',
              //   loadComponent: () => import('./pages/projects/approvals/approvals').then(m => m.Approvals),
              //   data: {
              //     objCode: 'PROJECT',
              //     objName: 'Project',
              //     title: 'Project Approvals | WorkLuge',
              //     description: 'WorkLuge Project Approvals'
              //   },
              // },
            ]
          },
          {
            path: 'template',
            children: [
              {
                path: 'template-details/:templateId',
                loadComponent: () => import('./pages/projects/templates/template-details/template-details').then(m => m.TemplateDetails),
                data: {
                  title: 'Template Details | WorkLuge',
                  description: 'WorkLuge Template Details'
                },
              }
            ]
          },
        ]
      },
      {
        path: 'task-listing',
        loadComponent: () => import('./pages/projects/tasks/task-list/task-list').then(m => m.TaskList),
        data: {
          title: 'Task Listing | WorkLuge',
          description: 'WorkLuge Task Listing - View and manage all tasks across projects. Filter tasks by status, assignee, or project. Track task progress, deadlines, and completion status.'
        },
      },
      {
        path: 'task',
        children: [
          {
            path: 'task-details/:taskId',
            loadComponent: () => import('./pages/projects/tasks/task-details/task-details').then(m => m.TaskDetails),
            data: {
              title: 'Task Details | WorkLuge',
              description: 'WorkLuge Task Details - View detailed task information, track progress, log time, add comments, and manage task assignments. Monitor task status and collaborate with team members.'
            },
            children: [
              { path: '', redirectTo: 'updates', pathMatch: 'full' },
              {
                path: 'updates',
                loadComponent: () => import('./pages/projects/updates/updates').then(m => m.UpdatesComponent),
                data: {
                  objCode: 'TASK',
                  objName: 'Task',
                  title: 'Task Updates | WorkLuge',
                  description: 'WorkLuge Task Updates'
                }
              },
              {
                path: 'issues',
                loadComponent: () => import('./pages/projects/issues/issue-listing/issue-listing').then(m => m.IssueListing),
                data: {
                  objCode: 'TASK',
                  title: 'Task Issues | WorkLuge',
                  description: 'WorkLuge Task Issues'
                },
              },
              {
                path: 'revisions',
                loadComponent: () => import('./pages/projects/revisions/revision-listing/revision-listing').then(m => m.RevisionListing),
                data: {
                  objCode: 'TASK',
                  title: 'Task Revision | WorkLuge',
                  description: 'WorkLuge Task Revision'
                },
              },
              {
                path: 'hours',
                loadComponent: () => import('./pages/projects/hours/hours-listing/hours-listing').then(m => m.HoursListing),
                data: {
                  objCode: 'TASK',
                  objName: 'Task',
                  title: 'Task Hours | WorkLuge',
                  description: 'WorkLuge Task Hours'
                },
              },
              {
                path: 'approvals',
                loadComponent: () => import('./pages/projects/approvals/approvals').then(m => m.Approvals),
                data: {
                  objCode: 'TASK',
                  objName: 'Task',
                  title: 'Task Approvals | WorkLuge',
                  description: 'WorkLuge Task Approvals'
                },
              },
              {
                path: 'documents',
                loadComponent: () => import('./pages/projects/project-details/documents/documents').then(m => m.DocumentsComponent),
                data: {
                  objCode: 'TASK',
                  objName: 'Task',
                  title: 'Task Documents | WorkLuge',
                  description: 'WorkLuge Task Documents'
                },
              },
            ]
          },
          {
            path: 'task-details/:taskId/edit',
            loadComponent: () => import('./pages/projects/tasks/edit-task-form/edit-task-form').then(m => m.EditTaskForm),
            data: {
              title: 'Task Details | WorkLuge',
              description: 'WorkLuge Task Details'
            },
          },
          {
            path: 'task-details',
            loadComponent: () => import('./pages/projects/tasks/task-details/task-details').then(m => m.TaskDetails)
          }
        ]
      },
      {
        path: 'issue-listing',
        loadComponent: () => import('./pages/projects/issues/issue-listing/issue-listing').then(m => m.IssueListing),
        data: {
          title: 'Issue Listing | WorkLuge',
          description: 'WorkLuge Issue Listing - View and manage project issues and bugs. Track issue status, assign to team members, prioritize issues, and monitor resolution progress.'
        },
      },
      {
        path: 'issue',
        children: [
          {
            path: 'issue-details/:issueId',
            loadComponent: () => import('./pages/projects/issues/issue-details/issue-details').then(m => m.IssueDetails),
            data: {
              title: 'Issue Details | WorkLuge',
              description: 'WorkLuge Issue Details'
            },
            children: [
              { path: '', redirectTo: 'updates', pathMatch: 'full' },
              {
                path: 'updates',
                loadComponent: () => import('./pages/projects/updates/updates').then(m => m.UpdatesComponent),
                data: {
                  objCode: 'ISSUE',
                  objName: 'Issue',
                  title: 'Issue Updates | WorkLuge',
                  description: 'WorkLuge Issue Updates'
                }
              },
              {
                path: 'revisions',
                loadComponent: () => import('./pages/projects/revisions/revision-listing/revision-listing').then(m => m.RevisionListing),
                data: {
                  objCode: 'ISSUE',
                  title: 'Issue Revisions | WorkLuge',
                  description: 'WorkLuge Issue Revisions'
                },
              },
              {
                path: 'approvals',
                loadComponent: () => import('./pages/projects/approvals/approvals').then(m => m.Approvals),
                data: {
                  objCode: 'ISSUE',
                  objName: 'Issue',
                  title: 'Issue Approvals | WorkLuge',
                  description: 'WorkLuge Issue Approvals'
                },
              },
              {
                path: 'documents',
                loadComponent: () => import('./pages/projects/project-details/documents/documents').then(m => m.DocumentsComponent),
                data: {
                  objCode: 'ISSUE',
                  objName: 'Issue',
                  title: 'Issue Documents | WorkLuge',
                  description: 'WorkLuge Issue Documents'
                },
              }
            ]
          }
        ]
      },
      {
        path: 'revision-listing',
        loadComponent: () => import('./pages/projects/revisions/revision-listing/revision-listing').then(m => m.RevisionListing),
        data: {
          title: 'Revision Listing | WorkLuge',
          description: 'WorkLuge Revision Listing - Manage project revisions and version control. Track document changes, review revisions, and maintain project version history.'
        },
      },
      {
        path: 'revision',
        children: [
          {
            path: 'revision-details/:revisionId',
            loadComponent: () => import('./pages/projects/revisions/revision-details/revision-details').then(m => m.RevisionDetails),
            data: {
              title: 'Revision Details | WorkLuge',
              description: 'WorkLuge Revision Details'
            },
            children: [
              { path: '', redirectTo: 'updates', pathMatch: 'full' },
              {
                path: 'updates',
                loadComponent: () => import('./pages/projects/updates/updates').then(m => m.UpdatesComponent),
                data: {
                  objCode: 'REVISION',
                  objName: 'Revision',
                  title: 'Revision Updates | WorkLuge',
                  description: 'WorkLuge Revision Updates'
                }
              },
              {
                path: 'hours',
                loadComponent: () => import('./pages/projects/hours/hours-listing/hours-listing').then(m => m.HoursListing),
                data: {
                  objCode: 'REVISION',
                  objName: 'Revision',
                  title: 'Revision Hours | WorkLuge',
                  description: 'WorkLuge Revision Hours'
                },
              },
              {
                path: 'issues',
                loadComponent: () => import('./pages/projects/issues/issue-listing/issue-listing').then(m => m.IssueListing),
                data: {
                  objCode: 'REVISION',
                  title: 'Revision Issues | WorkLuge',
                  description: 'WorkLuge Revision Issues'
                },
              },
              {
                path: 'approvals',
                loadComponent: () => import('./pages/projects/approvals/approvals').then(m => m.Approvals),
                data: {
                  objCode: 'REVISION',
                  objName: 'Revision',
                  title: 'Revision Approvals | WorkLuge',
                  description: 'WorkLuge Revision Approvals'
                },
              },
              {
                path: 'documents',
                loadComponent: () => import('./pages/projects/project-details/documents/documents').then(m => m.DocumentsComponent),
                data: {
                  objCode: 'REVISION',
                  objName: 'Revision',
                  title: 'Revision Documents | WorkLuge',
                  description: 'WorkLuge Revision Documents'
                },
              }
            ]
          },
          // Base revision routes that redirect to revision listing
          {
            path: 'detail',
            redirectTo: 'revision-listing',
            pathMatch: 'full'
          },
          {
            path: 'updates',
            redirectTo: 'revision-listing',
            pathMatch: 'full'
          },
          {
            path: 'issues',
            redirectTo: 'revision-listing',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'clients-list',
        loadComponent: () => import('./pages/clients/clients-list/clients-list').then(m => m.ClientsList),
        data: {
          title: 'Clients List | WorkLuge',
          description: 'WorkLuge Clients List - Manage client information, view client projects, track client communications, and maintain client relationships. Access client-specific data and project history.',
          hideSidebar: false
        },
      },
      {
        path: 'reporting',
        loadComponent: () => import('./shared/components/coming-soon/coming-soon').then(m => m.ComingSoon),
        data: {
          title: 'Reporting | WorkLuge',
          description: 'WorkLuge Reporting - Generate comprehensive reports on project performance, team productivity, time tracking, and resource utilization. Access analytics and insights for better decision making.'
        },
      },
      {
        path: 'wysiwyg-test',
        loadComponent: () => import('./pages/wysiwyg-editor-test/wysiwyg-editor-test').then(m => m.WysiwygEditorTest),
        data: {
          title: 'Reporting | WorkLuge',
          description: 'WorkLuge Reporting'
        },
      },
      {
        path: 'wysiwyg-editor-audio',
        loadComponent: () => import('./pages/wysiwyg-editor-audio/wysiwyg-editor-audio').then(m => m.WysiwygEditorAudioComponent),
        data: {
          title: 'Wysiwyg editor audio | WorkLuge',
          description: 'WorkLuge Wysiwyg editor audio'
        },
      },
      {
        path: 'updates',
        loadComponent: () => import('./pages/projects/updates/updates').then(m => m.UpdatesComponent),
        data: {
          title: 'Updates | WorkLuge',
          description: 'WorkLuge Updates - View and manage project updates, team communications, and progress reports. Track project changes, team activities, and stay informed about project developments.'
        },
      },
      {
        path: 'notifications',
        loadComponent: () => import('./pages/notifications/notifications-listing/notifications-listing').then(m => m.NotificationsListing),
        data: {
          title: 'Notifications | WorkLuge',
          description: 'WorkLuge Notifications - Stay updated with real-time notifications about project changes, task assignments, deadline reminders, and team communications. Manage notification preferences and stay informed.'
        }
      },
      {
        path: 'custom-filter',
        loadComponent: () => import('./shared/components/custom-filter/custom-filter').then(m => m.CustomFilter),
         data: {
          title: 'Custom filter | WorkLuge',
          description: 'WorkLuge Custom filter'
        },
      },
      {
        path: 'date-range-picker',
        loadComponent: () => import('./shared/components/date-range-picker/date-range-picker').then(m => m.CustomDateRangeComponent),
         data: {
          title: 'Date picker | WorkLuge',
          description: 'WorkLuge Date picker'
        },
      },

      
      {
        path: 'people',
        loadComponent: () => PeopleListing,
        data: {
          title: 'People | WorkLuge',
          description: 'WorkLuge People - Manage team members, view employee information, track team performance, and organize your workforce. Add new team members, assign roles, and maintain team directories.'
        },
      },
      {
        path: 'people/teams',
        loadComponent: () => import('./pages/people/teams/teams').then(m => m.Teams),
        data: {
          title: 'Teams | WorkLuge',
          description: 'WorkLuge Teams - Organize team structures, manage team hierarchies, assign team leads, and track team performance. Create and manage different teams for better project organization.'
        },
      },
      {
        path: 'people/peopleview/:id',
        loadComponent: () => import('./pages/people/people-view/people-view').then(m => m.PeopleView),
        data: {
          title: 'User Activity | WorkLuge',
          description: 'WorkLuge User Activity - View detailed user activity logs, track work progress, monitor time entries, and analyze individual performance metrics. Get insights into user productivity and engagement.'
        },
      },
      {
        path: 'approvals',
        loadComponent: () => import('./pages/projects/approvals/approvals').then(m => m.Approvals),
        data: {
          title: 'Approvals | WorkLuge',
          description: 'WorkLuge Approvals - Manage approval workflows, review pending approvals, and process requests. Track approval status, assign approvers, and streamline the approval process for better efficiency.'
        },
      },
      {
        path: 'search',
        loadComponent: () => import('./pages/search/search').then(m => m.Search),
        data: {
          title: 'Search | WorkLuge',
          description: 'WorkLuge Search - Search across projects, tasks, people, and documents. Find information quickly with advanced search filters and get comprehensive results from your WorkLuge workspace.'
        },
      },


    ]
  },
  {
    path: 'error-screen', pathMatch: 'full',
    loadComponent: () => import('./shared/components/error-screen/error-screen').then(m => m.ErrorScreen),
    data: {
      title: 'Error | WorkLuge',
      description: 'WorkLuge Error'
    },
  },
  { path: '**', redirectTo: '/login' ,
    data: {
      title: 'Login | WorkLuge',
      description: 'WorkLuge Login'
    },
  } // Catch all route should be last
];
